import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

const LAYERS = [3, 2, 1];

export const TableroFlagsPanel = () => {
  const [flags, setFlags] = useState(null);

  useEffect(() => {
    api.get("/admin/tablero/flags").then((r) => setFlags(r.data)).catch(() => toast.error("No pudimos cargar los interruptores"));
  }, []);

  async function update(body) {
    try {
      const r = await api.put("/admin/tablero/flags", body);
      setFlags(r.data);
      toast.success("Interruptor actualizado");
    } catch {
      toast.error("No pudimos guardar el cambio");
    }
  }

  if (!flags) return null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 space-y-4" data-testid="admin-tablero-flags">
      <div>
        <h3 className="font-display text-lg font-bold text-slate-900">Tablero de talento</h3>
        <p className="text-sm text-slate-500">Al apagarlo se ocultan el banner y el tablero en todos los informes. No se borra ningún dato.</p>
      </div>
      <label className="flex items-center justify-between gap-4 py-2 border-b border-slate-100">
        <span className="font-semibold text-slate-800">Interruptor general</span>
        <Switch checked={flags.enabled} onCheckedChange={(v) => update({ enabled: v })} data-testid="admin-tablero-flag-general" />
      </label>
      <label className="flex items-center justify-between gap-4 py-2 border-b border-slate-100">
        <span>
          <span className="block font-semibold text-slate-800">Solo administrador</span>
          <span className="block text-xs text-slate-500">Con el general encendido, solo tu cuenta de administrador ve el banner y el tablero.</span>
        </span>
        <Switch checked={!!flags.admin_only} onCheckedChange={(v) => update({ admin_only: v })} data-testid="admin-tablero-flag-admin-only" />
      </label>
      {LAYERS.map((n) => {
        const implemented = flags.implemented.includes(n);
        return (
          <label key={n} className="flex items-center justify-between gap-4 py-1">
            <span className="text-slate-700">Capa {n}{implemented ? "" : " · aún no implantada"}</span>
            <Switch checked={!!flags.layers[n]} disabled={!implemented} onCheckedChange={(v) => update({ layers: { [`capa${n}`]: v } })} data-testid={`admin-tablero-flag-capa${n}`} />
          </label>
        );
      })}
    </div>
  );
};
